import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from "react-oidc-context";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './lib/fonts/css/satoshi.css';
import {
  COGNITO_AUTHORITY,
  COGNITO_CLIENT_ID,
  COGNITO_REDIRECT_URI
} from './config/configCognito';
import { isDesignMode } from './config/designMode';
import { DesignApp } from './design/DesignApp';

const container = document.getElementById('root');
if (!container) {
  throw new Error("Root element with id 'root' not found. Make sure there's an element with id='root' in your HTML.");
}

const root = ReactDOM.createRoot(container);

if (isDesignMode) {
  root.render(
    <React.StrictMode>
      <DesignApp />
    </React.StrictMode>
  );
} else {
  const { REACT_APP_BASE_WEB_URL } = process.env;

  const cognitoAuthConfig = {
    authority: COGNITO_AUTHORITY,
    client_id: COGNITO_CLIENT_ID,
    redirect_uri: COGNITO_REDIRECT_URI,
    post_logout_redirect_uri: `${REACT_APP_BASE_WEB_URL}/login`,
    response_type: "code",
    scope: "email openid phone",
  };

  root.render(
    <React.StrictMode>
      <AuthProvider
        {...cognitoAuthConfig}
        onSigninCallback={() => {
          window.history.replaceState({}, document.title, window.location.pathname);
        }}
      >
        <App />
      </AuthProvider>
    </React.StrictMode>
  );
}

reportWebVitals();
